module.exports = __webpack_public_path__ + "img/pagamento onlne.c6b5911f.jpg";